import React from 'react';
import styled from 'styled-components';

const TagGroupWrapper = styled('div')`
  display: flex;
  align-items: start;
  justify-content: flex-start;
  margin-top: ${props => (props.marginTop ? props.marginTop : 0)};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : 0)};
  width: 100%;
  background-color: #ffffff;
  margin-top: 5px;
  border-radius: 3px;
`;

const Label = styled('span')`
  font-weight: bold;
  font-size: 20px;
  border-radius: 3px;
  color: #51bdd5;
`;

const TagWrapper = styled('span')`
  display: inline-block;
  padding: 0 12px;
  height: 30px;
  line-height: 30px;
  border-radius: 3px;
  opacity: 1;
  color: ${props => (props.color ? props.color : 'white')};
  font-size: ${props => (props.size ? props.size : '15px')};
  background-color: ${props => (props.bg ? props.bg : '#00BCD4')};
  font-weight: 400;
  cursor: pointer;
  transition-duration: 0.3s;
  &:hover {
    background-color: #002f3f;
  }
`;

const Tag = ({ style, bgColor, size, tagColor, tagContent }) => (
  <TagWrapper style={style} bg={bgColor} size={size} color={tagColor}>
    {tagContent}
  </TagWrapper>
);

export const LabelTag = props => (
  <Label style={props.style}>{props.tagContent}</Label>
);

export const TagGroup = props => (
  <TagGroupWrapper
    marginBottom={props.marginBottom}
    marginTop={props.marginTop}
    style={props.style}
  >
    {props.children}
  </TagGroupWrapper>
);

export default Tag;
